// extracted by mini-css-extract-plugin
module.exports = {"iconLink":"_4a4df61"};